import {
  limitToLast,
  onValue,
  orderByChild,
  query,
  ref
} from "firebase/database";
import { create } from "zustand";
import { db } from "../lib/firebase";
interface coinsState {
  coins: {};
  activeWebsockets: string[];
  coinMarketGlobal: any[];
  setActiveWebsockets: (websockets: string[]) => void;
  updateCoin: (symbol: string, coin: any) => void;
  clearCoins: () => void;
}

export const useCoinsStore = create<coinsState>(set => ({
  coins: {},
  activeWebsockets: [],
  coinMarketGlobal: [],
  setActiveWebsockets: (websockets: string[]) =>
    set(() => ({ activeWebsockets: websockets })),
  updateCoin: (symbol: string, coin: any) =>
    set(state => ({ coins: { ...state.coins, [symbol]: coin } })),
  clearCoins: () => set({ coins: [] })
}));

const coinMarketCapRef = ref(db, "coinmarketGlobal/");

const queryCoinMarketCap = query(
  coinMarketCapRef,
  orderByChild("timestamp"),
  limitToLast(5)
);

onValue(queryCoinMarketCap, snapshot => {
  const data = snapshot.val();

  if (data) {
    const coinMarketGlobalMapped = Object.keys(data)
      .map((key: any) => ({
        ...data[key],
        id: key
      }))
      .reverse();

    useCoinsStore.setState({
      coinMarketGlobal: coinMarketGlobalMapped
    });
  }
});
